import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { HostelService } from 'src/app/private/services/hostel.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-hostel',
  imports: [SharedModule],
  templateUrl: './delete-hostel.component.html',
  styleUrl: './delete-hostel.component.scss'
})
export class DeleteHostelComponent {

 @Output() closeDialog = new EventEmitter<any>();
  @Input() hostelData: any;
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api : HostelService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {}

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleDelete(){
    this.isLoading = true;

    const payload = {
      id : this.hostelData.id,
      organization_id : this.localStorage.getOrganizationId(),
      campus_id : this.localStorage.getCampusId()
    }

    this.api.deleteHostelCategory(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({severity:'success', summary: 'Success', detail: 'Hostel category deleted successfully'});
        this.closeDialog.emit();
      },
      error: (error) => {
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Something went wrong'});
        this.isLoading = false;
      }
    }
    );

  }

}
